import FuseScrollbars from '@fuse/core/FuseScrollbars';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import Navigation from 'app/fuse-layouts/shared-components/Navigation';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import React from 'react';
import Hidden from '@material-ui/core/Hidden';

function NavbarLayout2() {
	return (
		<div className="flex flex-auto items-center w-full h-full container px-16 lg:px-24">
			{/* 手機版漢堡選單按鈕 */}
			<Hidden mdUp>
				<NavbarMobileToggleButton className="w-40 h-40 p-0" />
			</Hidden>

			{/* 桌面版 Logo + 導覽列 */}
			<Hidden smDown>
				<div className="flex flex-shrink-0 items-center px-8">
					<Logo />
				</div>
				<FuseScrollbars className="flex h-full items-center">
					<Navigation className="w-full" layout="horizontal" dense />
				</FuseScrollbars>
			</Hidden>

			<div style={{ marginLeft: 'auto', marginRight: 0 }} className="flex items-center px-16">
				<LanguageSwitcher />
			</div>
		</div>
	);
}

export default React.memo(NavbarLayout2);
